const BASE_PATH = 'v1/account';
// authentication router
const SIGN_IN_PATH = '/sign-in';
const SIGN_UP_PATH = 'sign-up';
const SIGN_UP_CHOOSE_PARTNER_PATH = 'choose-partner';
const FORGOT_PASSWORD_PATH = 'forgot-password';
const RESET_PASSWORD_PATH = `${BASE_PATH}/:emailToken`;
const PRIVACY = 'privacy';
const SIGN_UP_CHOOSE_PARTNER = 'sign-up/choose-partner';
const CONFIRM_SIGNUP_EMAIL_PATH = 'confirm-signup-email';
const SIGN_UP_VERIFY_EMAIL_PATH = 'verify-email'
const SUCCESS_CONFIRM_SIGNUP_EMAIL_PATH = 'success-confirm-signup-email';
const ERROR_CONFIRM_SIGNUP_EMAIL_PATH = 'error-confirm-signup-email';
export {
  SIGN_IN_PATH,
  SIGN_UP_PATH,
  SIGN_UP_CHOOSE_PARTNER_PATH,
  FORGOT_PASSWORD_PATH,
  RESET_PASSWORD_PATH,
  PRIVACY,
  SIGN_UP_CHOOSE_PARTNER,
  CONFIRM_SIGNUP_EMAIL_PATH,
  SIGN_UP_VERIFY_EMAIL_PATH,
  SUCCESS_CONFIRM_SIGNUP_EMAIL_PATH,
  ERROR_CONFIRM_SIGNUP_EMAIL_PATH
};
